<template>
  <div class="col-12 relative grey-bg full-height flex flex-column">
    <!-- <template v-if="routeMatchesComponent() || !route.meta.breadcrumb">
      <CategoryHeader :title="route.meta.title" :icon="route.meta.icon" />
    </template> -->
    <div v-if="loading" class="relative full-height flex items-center justify-center pb5">
      <div class="center">
        <div class="list-loader-blue"></div>
      </div>
    </div>

    <div v-else class="p3">
      <div v-for="(participant,index) in participants" :key="participant.uuid" class="flex flex-wrap m0 p0" :class="{'mt2': index != 0}">
        <Collapsable class="col-12" @openCollapsableData="openCollapsable" :data="participant">
          <template v-slot:header>
            <strong>Participant: </strong>{{ participant.fullname }}
          </template>
          <template v-slot:content>
            <div v-if="participant.loading" class="p2">
              <Loader class="flex" />
            </div>
            <div v-else>
              <div v-if="participant.license" class="p2">
                <div v-for="field in fields" :key="field.value" :class="`inline-block col-${field.col} ${field.class}`">
                  <label class="h6n bold" :for="field.value">{{ field.label }}</label>
                  <div class="relative mb1 col-12">
                    <input
                      :id="field.value"
                      :ref="field.value"
                      v-model="participant.license[field.value]"
                      type="text"
                      class="border pl2 input-height col-12"
                      readonly
                    >
                  </div>
                </div>
              </div>
              <div class="h4n p2" v-else>
                Vous ne disposez pas de licence.
              </div>
            </div>

          </template>
        </Collapsable>
      </div>
    </div>
  </div>
</template>

<script>
  import { getCurrentInstance, onBeforeMount, ref, provide, computed } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { useStore } from 'vuex';

  import { routeIsCurrentComponent } from '@/mixins/utils';
  import { getCustomerLicense } from '@/mixins/requests';

  import CategoryHeader from '@/components/common/CategoryHeader';
  import Collapsable from '@/components/common/Collapsable';
  import Loader from "@/components/common/Loader";
  import { format, startOfYear, endOfYear } from 'date-fns'
  export default {
    components: { CategoryHeader, Collapsable, Loader },
    setup() {
      const router = useRouter();
      const route = useRoute();
      const store = useStore();

      const loading = ref(false)

      const participants = ref(store.state.contacts.map(p => ({ ...p, fullname: `${p.firstname} ${p.lastname}`, dataLoaded: false, loading: false, license: null })))

      const workspace = computed(() => store.state.siteInfo.workspace);

      const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

      const fields = computed(() => {
        return [
          { label: "Numéro de license", col: 12, value: "licenseNumber" },
          { label: "Date de début", col: 6, value: "licenseStartDate", class: "pr2" },
          { label: "Date de fin", col: 6, value: "licenseEndDate" }
        ]
      })

      const openCollapsable = async (participant) => {
        const participantIndex = participants.value.findIndex(p => p.uuid === participant.uuid)
        participants.value[participantIndex].loading = true

        if (!participant.dataLoaded) {
          // make request
          const response = await getCustomerLicense(participant.uuid, workspace.value)

          if (response && response.success && response.data && response.data.licenses && response.data.licenses.length){
            const license = response.data.licenses[0];
            if (license && license.data) {
              const date = `${license.data.pegase_license_year}-01-01`;

              participants.value[participantIndex].license = {
                licenseNumber: license.data.pegase_license_code,
                licenseStartDate: format(startOfYear(new Date(date)), 'dd-MM-yyyy'),
                licenseEndDate: format(endOfYear(new Date(date)), 'dd-MM-yyyy')
              }
            }
          }
          participants.value[participantIndex].dataLoaded = true
        }
        participants.value[participantIndex].loading = false
      }
      return { fields, route, routeMatchesComponent, participants, loading, openCollapsable }
    }
  }
  
</script>

<style>

.collapsable-header {
  background-color: #d6d6d6;
}

</style>